import type { FaireProductEntity } from "../../entity_types/product";

export const p_m4aejqtf99: FaireProductEntity = {
  token: "p_m4aejqtf99",
  type: "product",
  name: "Tea Bag Set",
  brandToken: "b_xvt273bhwc",
  brandName: "Herbal Rose Apothecary",
  imageUrl:
    "https://cdn.faire.com/fastly/b62547d72d60b5b6460c4ad8859ca9348aa0e36d532d4975f6ece92575f82c49.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9559221dbd8834b6e0e0fb7be58addfc5c4c478fa190bf1cef1d2e793f694766.jpeg",
  ],
  priceDollars: 2.76,
  description:
    "Disposable drawstring tea filter bags are made of non-woven material, sturdy and are resistant to high temperatures.\n\nEasy to Use: designed with drawstrings, easy to close and open, with fine and permeable mesh, can keep your tea leaves or powder safe in the bag without slipping out to the water, and easy to dispose after using.\n\nTea filter bags measuring approximately 2x2.76 inches and recommended for loose leaf teas.\n\n**NEW...White label products available (white label means no brand label on products, you add your own brand label)\n\nSets include:\n5 tea bags\n10 tea bags",
  tags: [],
  msrpDollars: 5.52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:59.442Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
